<!-- 电站设置 -->
<template>
  <div class="app-container">
    <div class="app-content">
      <el-card
        v-loading="stationLoading"
        element-loading-text="加载电站信息中..."
        element-loading-spinner="el-icon-loading"
        element-loading-background="rgba(0, 0, 0, 0.8)"
        class="energy-station__update"
        shadow="never"
      >
        <el-form ref="updateEnergyStationFormRef" :model="station" :rules="rules">
          <el-form-item label="电站图片 仅支持jpg、jpeg、png格式">
            <img-upload ref="imgUpload" v-model="station.img" style="width: 100%;display: inline-block;" />
          </el-form-item>
          <el-form-item label="电站名称" prop="orgname">
            <el-input
              v-model="station.orgname"
              clearable
            />
          </el-form-item>
          <el-form-item label="所属省份" prop="province">
            <el-select v-model="station.province" clearable filterable>
              <el-option v-for="(item,index) in provinceOptions" :key="index" :label="item.key" :value="item.value" />
            </el-select>
          </el-form-item>
          <el-form-item label="时区" prop="tzonecode">
            <el-select v-model="station.tzonecode" clearable filterable>
              <el-option v-for="(item,index) in timezoneOptions" :key="index" :label="item.key" :value="item.value" />
            </el-select>
          </el-form-item>
          <el-form-item label="装机容量 单位 kWp" prop="capacity">
            <el-input-number v-model="station.capacity" clearable :min="0" controls-position="right" />
          </el-form-item>
          <el-form-item>
            <el-button
              type="primary"
              :loading="updateLoading"
              @click="handleSave"
            >{{ $t('button.bc') }}</el-button>
          </el-form-item>
        </el-form>
      </el-card>
    </div>
  </div>
</template>

<script>
import ImgUpload from '@views/Imgupload'
import { GetTimeZones, GetAddresses } from '@apis/Universal.js'
import { UpdateEnergyStation, GetStation } from '@apis/Stations.js'
export default {
  components: {
    ImgUpload
  },
  data () {
    return {
      /** 省份选项 */
      provinceOptions: [],
      /** 时区选项 */
      timezoneOptions: [
        {
          'value': '101',
          'key': '(GMT+08:00) 北京，重庆，香港特别行政区，乌鲁木齐'
        }
      ],
      /** 维护站信息加载中 */
      stationLoading: false,
      /** 维护站信息 */
      station: {
        id: '',
        img: '',
        orgname: '',
        province: '',
        tzonecode: '101',
        capacity: '',
      },
      /** 表单验证规则 */
      rules: {
        orgname: [
          { required: true, message: '请输入电站名称', trigger: 'blur' }
        ],
        province: [
          { required: true, message: '请选择所属省份', trigger: 'change' }
        ],
        tzonecode: [
          { required: true, message: '请选择时区', trigger: 'change' }
        ],
        capacity: [
          { required: true, message: '请输入装机容量', trigger: 'blur' }
        ]
      },
      /** 更新加载中 */
      updateLoading: false,
    }
  },
  mounted () {
    this.getTimeZoneAndProvinceOptions().then(() => {
      this.setStation()
    })
  },
  methods: {

    /** 获取时区和省份选项 */
    getTimeZoneAndProvinceOptions () {
      return new Promise((resolve, reject) => {
        Promise.all([GetTimeZones({ id: '' }), GetAddresses({ id: '44' })]).then(res => {
          this.timezoneOptions = res[0].data
          this.provinceOptions = res[1].data
          resolve(res)
        }).catch(err => {
          console.log(err)
          this.$message({
            message: '获取选项失败',
            type: 'error'
          })
          reject(err)
        })
      })
    },

    /** 设置维护站信息 */
    setStation () {
      this.station.id = this.$store.getters.station.id
      this.stationLoading = true
      GetStation({
        id: this.station.id
      }).then(res => {
        this.station.orgname = res.data.orgname
        this.station.province = res.data.province
        this.station.tzonecode = res.data.tzonecode
        this.station.capacity = res.data.capacity
        return res.data.img
      }).then((img) => {
        this.station.img = `${process.env.VUE_APP_BASE_API}/imgs/stations/${img}`
      }).then(() => {
        this.stationLoading = false
      }).catch(() => {
        this.stationLoading = false
        this.$message({
          message: this.$t('notice.bjcsb'),
          type: 'error'
        })
      })
    },

    /** 保存维护站信息 */
    handleSave () {
      this.$refs.updateEnergyStationFormRef.validate((validateResult) => {
        if (validateResult) {
          this.updateLoading = true
          const postData = {
            ...this.station,
          }
          if (postData.img.indexOf('base64') === -1) {
            postData.img = null
          }
          UpdateEnergyStation(postData).then(() => {
            this.$message({
              message: this.$t('notice.bjcg'),
              type: 'success'
            })
            this.updateLoading = false
          }).catch(() => {
            this.$message({
              message: '更新失败',
              type: 'error'
            })
            this.updateLoading = false
          })
        }
      })
    }
  }
}
</script>
<style scoped>
.energy-station__update {
  width: 100%;
  height: 100%;
  padding: 0;
  box-sizing: border-box;
  background-color: var(--card-bg-color);
  border-color: var(--card-bg-color);
}
.energy-station__update >>>.el-card__body{
  width: 100%;
  height: 100%;
  padding: 20px;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: center;
}
.energy-station__update >>>.el-card__body .el-form{
  width: 100%;
  height: 100%;
  padding: 0px;
  box-sizing: border-box;
}
</style>

